import React, {useEffect, useState} from 'react'
import '../css/ButtonSearch.scss'

export default props => {
    const {
        onClick,
        active,
        text
    } = props

    const [isClicked, setIsClicked] = useState(false)

    const handleClick = () => {
        if (isClicked) return
        setIsClicked(true)
        onClick()
    }

    useEffect(() => {
        if(!active && isClicked) setIsClicked(false)
    }, [active, isClicked])

    return (
        <div className='button-search-container' onClick={handleClick}>
            <div className={`button-search-content${isClicked && active ? ' loading' : ''}`}>
                {isClicked && active? 
                    <div className='canarias-spinner-inline'></div>
                 : text }
            </div>            
        </div>
    )
}
